import React, { useState } from "react";
import api, { fmtINR } from "@/lib/api";
import { toast } from "sonner";

export default function TrackOrder() {
  const [orderNumber, setOrderNumber] = useState("");
  const [mobile, setMobile] = useState("");
  const [order, setOrder] = useState(null);

  const track = async () => {
    if (!orderNumber || !mobile) return toast.error("Enter order number and mobile");
    try {
      const r = await api.get(`/orders/track/${orderNumber}`, { params: { mobile } });
      setOrder(r.data);
    } catch {
      toast.error("Order not found");
      setOrder(null);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14" data-testid="track-order-page">
      <h1 className="font-heading text-3xl sm:text-4xl font-bold text-[#0A192F]">Track Your Order</h1>
      <p className="text-slate-600 mt-2">Enter your order number and registered mobile to see status.</p>
      <div className="mt-8 grid sm:grid-cols-2 gap-3">
        <input placeholder="Order number (e.g. KSPB26011001)" value={orderNumber} onChange={(e) => setOrderNumber(e.target.value)} className="h-12 px-4 rounded-lg border border-slate-200" data-testid="track-order-num" />
        <input placeholder="Registered mobile" value={mobile} onChange={(e) => setMobile(e.target.value)} className="h-12 px-4 rounded-lg border border-slate-200" data-testid="track-mobile" />
      </div>
      <button onClick={track} className="mt-4 h-12 px-6 rounded-full bg-[#FF6D00] text-white font-semibold" data-testid="track-submit">Track</button>

      {order && (
        <div className="mt-10 p-6 rounded-2xl border border-slate-200 bg-white">
          <div className="flex flex-wrap justify-between gap-4">
            <div>
              <div className="text-xs uppercase tracking-widest text-slate-500">Order</div>
              <div className="font-heading text-xl font-bold text-[#0A192F]">{order.order_number}</div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-slate-500">Status</div>
              <div className="font-semibold text-[#FF6D00] capitalize">{order.status}</div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-slate-500">Payment</div>
              <div className="font-semibold capitalize">{order.payment_method} · {order.payment_status}</div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-slate-500">Total</div>
              <div className="font-heading text-xl font-bold text-[#0A192F]">{fmtINR(order.total)}</div>
            </div>
          </div>
          <div className="mt-6 pt-6 border-t border-slate-200">
            <div className="text-xs uppercase tracking-widest text-slate-500 mb-3">Items</div>
            {order.items.map((it, i) => (
              <div key={i} className="flex justify-between py-2 text-sm">
                <span>{it.name} × {it.quantity}</span><span>{fmtINR(it.line_total)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
